import {Component, OnInit, OnDestroy, Output, EventEmitter, Input, ElementRef} from '@angular/core';
import { Response } from '@angular/http';

import {UploadService} from './upload.service';
import {UserBlob} from './user-blob.model';
import {Subscription} from 'rxjs';

@Component({
    selector: 'jhi-upload',
    templateUrl: 'upload.component.html'
})
export class UploadComponent implements OnInit, OnDestroy {



    @Output() userBlobIdChange = new EventEmitter<string>();
    @Output() userBlobFilenameChange = new EventEmitter<string>();

    private _userBlobId: string;

    @Input()
    get userBlobId() {
        return this._userBlobId;
    }

    set userBlobId(id: string) {
        if (id !== this._userBlobId) {
            this._userBlobId = id;
            this.userBlobIdChange.emit(id);
        }
    }

    private _userBlobFilename: string;

    @Input()
    get userBlobFilename() {
        return this._userBlobFilename;
    }

    set userBlobFilename(filename: string) {
        if (filename !== this._userBlobFilename) {
            this._userBlobFilename = filename;
            this.userBlobFilenameChange.emit(filename);
        }
    }

    @Input() readonly: boolean;
    @Input() translationKey: string;
    @Input() ariaDescribedby: string;

    @Input() isNew: boolean;

    @Output() onUploadSuccess = new EventEmitter<UserBlob>();
    @Output() onUploadError = new EventEmitter<string | Response>();
    @Output() onDownloadSuccess = new EventEmitter<UserBlob>();
    @Output() onDownloadError = new EventEmitter<string | Response>();
    @Output() afterRemoveAttachement = new EventEmitter<number>();


    typeAcceptable: boolean;
    file: File;
    uploadAttempted = false;
    uploadSuccess = false;
    uploading = false;
    sizeExceedsLimit: boolean;
    latestUploadedUserBlob: UserBlob;
    performBlobUploadSubscription: Subscription;
    generatedId = Math.random().toString(36).substring(2);

    constructor(
        private uploadService: UploadService,
        private elementRef: ElementRef
    ) {
    }

    ngOnInit() {

    }

    ngOnDestroy() {

    }
    clearFileData(input) {
        input.value = null;
    }

    setFileData($event) {
        this.uploadAttempted = false;
        this.uploadSuccess = false;
        this.typeAcceptable = true;
        if ($event.target.files && $event.target.files[0]) {
            let tmpFile = $event.target.files[0];
            if (tmpFile.size > this.uploadService.MAX_FILE_SIZE) {
                this.sizeExceedsLimit = true;
            } else {
                this.sizeExceedsLimit = false;
                this.file = tmpFile;
                this.uploadService.isAcceptableUploadContentType(this.file.type).subscribe(
                    acceptable => {
                        this.typeAcceptable = acceptable;
                        if (acceptable) {
                            this.performBlobUpload();
                        } else {
                            this.uploadAttempted = false;
                            this.userBlobFilename = null;
                            this.userBlobId = null;
                        }
                    }
                );
            }
        }
    }

    isUploadSuccess() {
        return this.uploadAttempted && this.uploadSuccess;
    }

    isUploadError() {
        return this.uploadAttempted && !this.uploadSuccess;
    }

    downloadUserBlob() {
        this.uploadService.downloadBlob(this.userBlobId);
    }

    performBlobUpload() {
        if (this.file) {
            this.cancelCurrentUploadIfAny();
            this.uploading = true;
            this.uploadAttempted = false;
            this.uploadSuccess = false;
            this.performBlobUploadSubscription = this.uploadService.uploadBlob(this.file).subscribe(
                this.uploadSuccessHandler,
                this.uploadErrorHandler
            );
        }
    }

    public cancelCurrentUploadIfAny() {
        if (this.uploading) {
            // An upload is currently running. Cancel it.
            this.uploadAttempted = false;
            this.uploadSuccess = false;
            this.latestUploadedUserBlob = null;
            this.performBlobUploadSubscription.unsubscribe();
            this.performBlobUploadSubscription = null;
            this.uploading = false;
            this.userBlobId = null;
            this.userBlobFilename = null;
        }
    }

    removeAttachment() {
        this.uploadAttempted = false;
        this.cancelCurrentUploadIfAny();
        this.userBlobId = null;
        this.userBlobFilename = null;

        if ( this.afterRemoveAttachement ) {
            this.afterRemoveAttachement.emit();
        }
        this.focusOnFirstButton();
    }

    uploadSuccessHandler = (userBlob: UserBlob) => {
        this.uploadAttempted = true;
        this.uploadSuccess = true;
        this.uploading = false;
        this.performBlobUploadSubscription.unsubscribe();
        this.performBlobUploadSubscription = null;
        this.latestUploadedUserBlob = userBlob;
        this.userBlobId = userBlob.id;
        this.userBlobFilename = userBlob.userBlobFilename;
        this.file = undefined;
        this.onUploadSuccess.emit(userBlob);
        this.focusOnUploadedDocument();
    }

    uploadErrorHandler = (error: string | Response) => {
        this.uploadAttempted = true;
        this.uploadSuccess = false;
        this.uploading = false;
        this.performBlobUploadSubscription.unsubscribe();
        this.performBlobUploadSubscription = null;
        this.latestUploadedUserBlob = null;
        this.userBlobId = null;
        this.userBlobFilename = null;
        this.onUploadError.emit(error);
    }

    focusOnUploadedDocument = () => {
        setTimeout(() => {
            const links = this.elementRef.nativeElement.getElementsByTagName('a');
            if (links.length) {
                links[0].focus();
            }
        }, 0);
    }

    focusOnFirstButton = () => {
        setTimeout(() => {
            const links = this.elementRef.nativeElement.getElementsByTagName('button');
            if (links.length) {
                links[0].focus();
            }
        }, 0);
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/upload/upload.component.ts